<h2 mat-dialog-title class="loren-trace-dialog-title">
  {{ title | transloco }}
</h2>
@if (subtitle) {
  <p class="loren-trace-dialog-subtitle">
    {{ subtitle | transloco }}
  </p>
}
<div class="dialog-selector-forms">
  <ng-content></ng-content>
</div>
<mat-dialog-actions>
  <div class="mt-3">
    <button mat-button mat-dialog-close>
      {{ "operations.cancel" | transloco }}
    </button>
    <button
      mat-button
      color="primary"
      [mat-dialog-close]="true"
      (click)="continue.emit(null)"
      >
      {{ "operations.continue" | transloco }}
    </button>
  </div>
</mat-dialog-actions>
